import { Card, Row, Col } from "react-bootstrap"

export default function SessionSection({ title, sessions }) {

  const getTimeRange = () => {
    switch(title.toLowerCase()) {
      case "morning":
        return ""
      case "afternoon":
        return "(Classes from 12:00 PM)"
      case "evening":
        return "(Classes from 04:00 PM)"
      default:
        return ""
    }
  }

  const formatTitle = () => {
    return title.toUpperCase()
  }

  return (
    <div className="session-section">

      {sessions.length > 0 ? (
        <>
          <h6 className="session-title">
            <span className="session-title-text">{formatTitle()}</span>
            {getTimeRange() && <span className="session-time-range">{getTimeRange()}</span>}
          </h6>
          <Row className="class-cards-row">
            {sessions.map((s, i) => (
              <Col lg={3} md={5} sm={12} key={i} className="class-card-col">
                <Card
                  className={`class-card ${s.name === "TAEKWON-DO" ? "card-bg-grey" : ""}`}
                  style={{ 
                    borderTopColor: s.name === "TAEKWON-DO" ? "#d0d0d0" : (s.color || "#d0d0d0"),
                    backgroundColor: s.name === "TAEKWON-DO" ? "#f5f5f5" : "white"
                  }}
                >
                  <Card.Body>
                    <Card.Title className="class-card-title">{s.name}</Card.Title>
                    <Card.Text className="class-time">
                      {s.time.split('\n').map((line, idx) => (
                        <span key={idx}>
                          {line}
                          {idx < s.time.split('\n').length - 1 && <br />}
                        </span>
                      ))}
                    </Card.Text>
                    {s.subtitle && (
                      <Card.Text className="class-subtitle">{s.subtitle}</Card.Text>
                    )}
                    <small className="class-duration">{s.duration}</small>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </>
      ) : (
        <>
          <h6 className="session-title">
            <span className="session-title-text">{formatTitle()}</span>
            {getTimeRange() && <span className="session-time-range">{getTimeRange()}</span>}
          </h6>
          <p className="no-classes-message">
            {title.toLowerCase() === "morning" ? "No afternoon classes" : "No afternoon classes."}
          </p>
        </>
      )}

    </div>
  )
}